import React from "react";
import PropTypes from "prop-types";
import WideHeader from "./wide-header/WideHeader";
import ModalHeader from "./modal-header/ModalHeader";
import appPath from "utils/appPath";

const Header = ({ title, closeable, children }) => {
    if (appPath.isIframePath()) {
        return (
            <ModalHeader title={ title } closeable={ closeable }>
                { children }
            </ModalHeader>
        );
    }

    return (
        <WideHeader title={ title }>
            { children }
        </WideHeader>
    );
};

Header.propTypes = {
    title: PropTypes.string,
    closeable: PropTypes.bool
};

export default Header;
